import type { Analytics } from '@mwl/core-lib';

export const promoFieldAnalytics: Analytics = {
  change: {
    eventName: 'userMenu_promocode_input',
  },
  check: {
    eventName: 'userMenu_promocode_check_btn_click',
  },
  success: {
    eventName: 'userMenu_promocode_checkSuccess',
  },
  click: {
    eventName: 'userMenu_promocode_getBonus_link_click',
  },
  error: {
    eventName: 'userMenu_promocode_checkFailed',
  },
};
